import styled from 'styled-components';

export const StyledLoaderWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding: 20px;
  min-height: 0;
`;
